import React from 'react'
import muiThemable from 'material-ui/styles/muiThemeable'
import PropTypes from 'prop-types'
import Paginate from 'react-paginate'
import styled from 'styled-components'
import cx from 'classnames'
import ArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left'
import ArrowRight from 'material-ui/svg-icons/hardware/keyboard-arrow-right'

const Pagination = styled(
  muiThemable()(
    ({
      className,
      pageCount,
      onPageChange,
      muiTheme: {
        palette: {
          accent1Color,
        },
      },
    }) => {
      return (
        <Paginate
          containerClassName={cx('paginate-container', className)}
          pageClassName={'paginate-page'}
          pageLinkClassName={'paginate-link'}
          activeClassName={'paginate-active'}
          previousClassName={'previous'}
          nextClassName={'next'}
          pageCount={pageCount}
          marginPagesDisplayed={10}
          pageRangeDisplayed={10}
          onPageChange={({ selected: pageIndex }) => onPageChange(pageIndex)}
          previousLabel={(
            <ArrowLeft color={accent1Color} />
          )}
          nextLabel={(
            <ArrowRight color={accent1Color} />
          )}
        />
      )
    }
  )
)`
  &.paginate-container {
    list-style: none;
    padding: 0;
    display: flex;
    
    li {
      width: 40px;
      height: 40px;
      display: inline-flex;
      box-shadow: 0 0 1px 0 #d5d5d5;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      
      a {
        color: #000000;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        
        &:focus {
          outline: 0;
        }
      }
      
      &.disabled {
        cursor: initial;
      }
      
      &.paginate-active {
        background-color: #d5d5d5;
      }
      
      &.next, &.previous {
        a {
          display: flex;
          align-items: center;
        }
      }
    }
  }
`

Pagination.propTypes = {
  pageCount: PropTypes.number.isRequired,
  onPageChange: PropTypes.func,
}
Pagination.defaultProps = {
  onPageChange: () => {},
}

export default Pagination



// WEBPACK FOOTER //
// ./src/components/Navigator/Pagination.js